import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const cartItemCount = cartItems.reduce(
    (total, item) => total + item.quantity,
    0
  );

  return (
    <header className="site-header">
      <div className="header-container">
        <Link
          to="/"
          className="logo"
          onClick={toTop}
          aria-label="Tuddlepetgoods home"
        >
          <img src="/head/tuddlepetgoods-mark.svg" alt="" />
        </Link>

        <nav className="main-nav">
          <Link to="/about" onClick={toTop}>
            ABOUT
          </Link>
          <Link to="/shop" onClick={toTop}>
            NEW
          </Link>

          <Link to="/contact" onClick={toTop}>
            CONTACT
          </Link>
          <details className="more-menu">
            <summary>MORE</summary>
            <div className="more-menu__panel">
              <Link to="/policies" onClick={toTop}>POLICY CENTER</Link>
              <Link to="/privacy" onClick={toTop}>PRIVACY</Link>
              <Link to="/terms" onClick={toTop}>TERMS</Link>
              <Link to="/shipping" onClick={toTop}>SHIPPING</Link>
              <Link to="/returns" onClick={toTop}>REFUNDS</Link>
              <Link to="/faqs" onClick={toTop}>FAQS</Link>
              <Link to="/cookies" onClick={toTop}>COOKIES</Link>
            </div>
          </details>
        </nav>

        <div className="header-icons">
          <Link to="/cartpage" className="icon-btn cart-btn">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <circle cx="9" cy="21" r="1"></circle>
              <circle cx="20" cy="21" r="1"></circle>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
            {cartItemCount > 0 && (
              <span className="cart-count">{cartItemCount}</span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
